import React from 'react';
import { Pagination } from 'antd';

const Paging = ({ ...props }) => (<Pagination size="small" {...props} />);

export default Paging;